import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { verifyEmail } from '../contexts/db.User';
import { translations } from '../translations';
import '../styles/pages/Auth.css';

function VerifyEmail({ language }) {
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const t = translations[language] || translations.en;

  useEffect(() => {
    const verifyUserEmail = async () => {
      try {
        // Get token from URL query parameters
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const email = params.get('email');

        if (!token || !email) {
          setStatus('error');
          setError(t.invalidVerificationLink || 'Invalid verification link');
          return;
        }

        // Call API to verify email
        const response = await verifyEmail(email, token);
        
        if (response && response.success) {
          setStatus('success');
          // Redirect to Plans page after 3 seconds
          setTimeout(() => {
            navigate('/plans', { state: { userId: response.userId } });
          }, 3000);
        } else {
          setStatus('error');
          setError(response.message || t.verificationFailed || 'Verification failed');
        }
      } catch (error) {
        console.error('Email verification error:', error);
        setStatus('error');
        setError(t.verificationError || 'An error occurred during verification');
      }
    };

    verifyUserEmail();
  }, [location, navigate, t]);

  return (
    <div className="auth-container">
      <div className="auth-content centered">
        <div className="verification-container">
          <h1>{t.emailVerification || 'Email Verification'}</h1>

          {status === 'verifying' && (
            <div className="verification-status">
              <div className="loading-spinner"></div>
              <p>{t.verifyingEmail || 'Verifying your email...'}</p>
            </div>
          )}

          {status === 'success' && (
            <div className="verification-status success">
              <div className="success-icon">✓</div>
              <h2>{t.verificationSuccess || 'Verification Successful!'}</h2>
              <p>{t.redirectingToPlans || 'You will be redirected to the plans page shortly...'}</p>
            </div>
          )}

          {status === 'error' && (
            <div className="verification-status error">
              <div className="error-icon">✗</div>
              <h2>{t.verificationFailed || 'Verification Failed'}</h2>
              <p>{error}</p>
              <button 
                className="submit-button" 
                onClick={() => navigate('/register')}
              >
                {t.backToRegister || 'Back to Register'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
